import {
  EVENT,
  LIST_OF_CALENDAR_EVENTS,
  CALENDAR_EVENTS_LISTING,
  CALENDAR_EVENTS_WITH_ACTIVITIES,
  CALENDAR_EVENT_NOTES,
  CALENDAR_ACCOUNT_OPTIONS,
  CALENDAR_CONTACT_OPTIONS,
} from './queries';
import {
  ADD_EVENT_NOTE,
  RE_DATE_EVENT_ACTIVITIES,
  COMPLETE_EVENT_ACTIVITIES,
  MOVE_TO_TOMORROW_DATE_EVENT_ACTIVITIES,
} from './mutations';

export const eventsApi = {
  queries: {
    event: EVENT,
    list: LIST_OF_CALENDAR_EVENTS,
    listWithActivities: CALENDAR_EVENTS_WITH_ACTIVITIES,
    listing: CALENDAR_EVENTS_LISTING,
    eventNotes: CALENDAR_EVENT_NOTES,
    accountOptions: CALENDAR_ACCOUNT_OPTIONS,
    contactOptions: CALENDAR_CONTACT_OPTIONS,
  },
  mutations: {
    addEventNote: ADD_EVENT_NOTE,
    reDate: RE_DATE_EVENT_ACTIVITIES,
    complete: COMPLETE_EVENT_ACTIVITIES,
    moveToTomorrow: MOVE_TO_TOMORROW_DATE_EVENT_ACTIVITIES,
  },
};
